import { useEffect, useState } from "react";
import GroupServersRequests from "../../../../../Services/Api/GroupServersRequests.ts";
import AddServerModal from "./Components/AddServerModal/AddServerModal.js";
import ScrollableList from "../../../../../Components/ScrollableList/ScrollableList.js";
import { GetServerParsedName } from "../../../../../Services/Servers/ServerHelper.js";

const groupServersRequests = new GroupServersRequests();

const GroupServers = ({groupId}) => {
    const [showAddServer, setShowAddServer] = useState(false);
    const[groupServers, setGroupServers] = useState(null);

    useEffect(() => {
        refresh();
    }, [groupId]);

    const processGroupServers = (groupServersData) => {
        const mapedData = groupServersData.map((groupServer) => {
            return {
                id: groupServer.id,
                columns:  <div dangerouslySetInnerHTML={{__html: GetServerParsedName(groupServer.serverObject.name)}}/>,
                text: GetServerParsedName(groupServer.serverObject.name),
                serverId : groupServer.serverObject.id,
        }})

        setGroupServers(mapedData)
    };

    const refresh = () =>{
        groupServersRequests.Get(groupId, processGroupServers)
    }

    const removeFunction = (id) => {
        groupServersRequests.Delete(id, () => {refresh()})
    }
    
    if(!groupServers)
        return (<div className="text-center">Ładowanie danych...</div>);


    return(
        <>
            <ScrollableList 
                setShowAdd={setShowAddServer}
                removeFunction={removeFunction}
                refresh={() => refresh()}
                title={"Serwery"}
                data={groupServers}
                listClass={"overflow-y-auto overflow-x-hidden max-h-[55vh]"}
                removeTitle={"Usuń serwer z grupy"}
            />

            { showAddServer &&
                <AddServerModal groupId={groupId} groupServers={groupServers} refresh={refresh} hide={() => setShowAddServer(false)}/>
            }            
        </>  
    )
}

export default GroupServers;